// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/SettingsPage.css */
.settings {
    max-width: 400px;
    margin: 0 auto;
    padding: 16px;
    font-family: sans-serif;
  }
  .settings h1 {
    text-align: center;
    margin-bottom: 16px;
  }
  .settings-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .profile-card {
    display: flex;
    align-items: center;
    position: relative;
    padding: 12px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  .profile-card .avatar {
    width: 56px;
    height: 56px;
    border-radius: 28px;
    margin-right: 12px;
  }
  .profile-info h2 {
    margin: 0;
    font-size: 18px;
  }
  .username {
    margin: 4px 0;
    color: #666;
    font-size: 14px;
  }
  .status {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    display: inline-block;
  }
  .status-dot.online { background: #4caf50; box-shadow: 0 0 4px rgba(76,175,80,0.6); }
  .status-dot.offline { background: #ccc; }
  .edit-icon {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 18px;
    cursor: pointer;
    color: #007bff;
  }
  .setting-item {
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    justify-content: space-between;
  }
  .setting-item.clickable {
    cursor: pointer;
  }
  .setting-item.clickable:hover {
    background: #f0f0f0;
  }
  .toggle-item span,
  .setting-item.clickable span {
    font-size: 16px;
    color: #333;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
  }
  .switch input { display:none; }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: #ccc;
    border-radius: 20px;
    transition: .4s;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: .4s;
  }
  input:checked + .slider {
    background-color: #4caf50;
  }
  input:checked + .slider:before {
    transform: translateX(20px);
  }
  .error-msg { color: #e74c3c; text-align: center; margin-top:16px; }
  .success-msg { color: #2ecc71; text-align: center; margin-top:16px; }
  
  /* Модалка */
  .modal-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 12px;
    width: 90%;
    max-width: 320px;
  }
  .modal-content h3 {
    margin-top: 0;
    margin-bottom: 12px;
  }
  .modal-field {
    margin-bottom: 12px;
  }
  .modal-field label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
  }
  .modal-field input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
  }
  .modal-actions button {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  .modal-actions button:first-child { background: #007bff; color: #fff; }
  .modal-actions button:last-child { background: #ccc; }
  `, "",{"version":3,"sources":["webpack://./src/modules/Base/SettingsPage/SettingsPage.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;EACvC;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;EACA,qBAAqB,mBAAmB,EAAE,uCAAuC,EAAE;EACnF,sBAAsB,gBAAgB,EAAE;EACxC;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,eAAe;IACf,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;EACA,gBAAgB,YAAY,EAAE;EAC9B;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA,aAAa,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;EAClE,eAAe,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;;EAEpE,YAAY;EACZ;IACE,eAAe;IACf,MAAM,EAAE,OAAO;IACf,WAAW,EAAE,YAAY;IACzB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;EACA,oCAAoC,mBAAmB,EAAE,WAAW,EAAE;EACtE,mCAAmC,gBAAgB,EAAE","sourcesContent":["/* src/pages/SettingsPage.css */\r\n.settings {\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n    padding: 16px;\r\n    font-family: sans-serif;\r\n  }\r\n  .settings h1 {\r\n    text-align: center;\r\n    margin-bottom: 16px;\r\n  }\r\n  .settings-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n  .profile-card {\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    padding: 12px;\r\n    border-radius: 12px;\r\n    background: #fff;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  }\r\n  .profile-card .avatar {\r\n    width: 56px;\r\n    height: 56px;\r\n    border-radius: 28px;\r\n    margin-right: 12px;\r\n  }\r\n  .profile-info h2 {\r\n    margin: 0;\r\n    font-size: 18px;\r\n  }\r\n  .username {\r\n    margin: 4px 0;\r\n    color: #666;\r\n    font-size: 14px;\r\n  }\r\n  .status {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n  }\r\n  .status-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 5px;\r\n    display: inline-block;\r\n  }\r\n  .status-dot.online { background: #4caf50; box-shadow: 0 0 4px rgba(76,175,80,0.6); }\r\n  .status-dot.offline { background: #ccc; }\r\n  .edit-icon {\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 12px;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    color: #007bff;\r\n  }\r\n  .setting-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 12px;\r\n    border-radius: 12px;\r\n    background: #fff;\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n    justify-content: space-between;\r\n  }\r\n  .setting-item.clickable {\r\n    cursor: pointer;\r\n  }\r\n  .setting-item.clickable:hover {\r\n    background: #f0f0f0;\r\n  }\r\n  .toggle-item span,\r\n  .setting-item.clickable span {\r\n    font-size: 16px;\r\n    color: #333;\r\n  }\r\n  .switch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 40px;\r\n    height: 20px;\r\n  }\r\n  .switch input { display:none; }\r\n  .slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0; left: 0; right: 0; bottom: 0;\r\n    background-color: #ccc;\r\n    border-radius: 20px;\r\n    transition: .4s;\r\n  }\r\n  .slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 16px;\r\n    width: 16px;\r\n    left: 2px;\r\n    bottom: 2px;\r\n    background-color: white;\r\n    border-radius: 50%;\r\n    transition: .4s;\r\n  }\r\n  input:checked + .slider {\r\n    background-color: #4caf50;\r\n  }\r\n  input:checked + .slider:before {\r\n    transform: translateX(20px);\r\n  }\r\n  .error-msg { color: #e74c3c; text-align: center; margin-top:16px; }\r\n  .success-msg { color: #2ecc71; text-align: center; margin-top:16px; }\r\n  \r\n  /* Модалка */\r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0; left: 0;\r\n    width: 100%; height: 100%;\r\n    background: rgba(0,0,0,0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n  }\r\n  .modal-content {\r\n    background: #fff;\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    width: 90%;\r\n    max-width: 320px;\r\n  }\r\n  .modal-content h3 {\r\n    margin-top: 0;\r\n    margin-bottom: 12px;\r\n  }\r\n  .modal-field {\r\n    margin-bottom: 12px;\r\n  }\r\n  .modal-field label {\r\n    display: block;\r\n    margin-bottom: 4px;\r\n    font-size: 14px;\r\n  }\r\n  .modal-field input {\r\n    width: 100%;\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n  .modal-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n    margin-top: 12px;\r\n  }\r\n  .modal-actions button {\r\n    padding: 6px 12px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  .modal-actions button:first-child { background: #007bff; color: #fff; }\r\n  .modal-actions button:last-child { background: #ccc; }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
